module.exports = __webpack_public_path__ + "img/cp-0.dc696d86.png";